const TEXT = {
    PERSONAL_DETAILS: {
        HEADING_BANK_ID_VERIFIED: "Vi hentet disse opplysningene fra BankID",
        EMAIL: "E-post",
        PHONENUMBER: "Telefonnummer",
    },
    ADDRESSES: {
        CHANGE_APARTMENT: "Endre leilighet",
        SHOW_ALL_APARTMENTS: "Vis alle leiligheter",
        LOADING_VAID: "Sjekker adressen ...",
        LOADING_HEADING: "Et lite øyeblikk",
        LOADING_ADDRESSES: "Vi henter info og finner riktige priser til deg",
    },
    BUTTON: {
        TELIANO_PAGE: "Tilbake til telia.no",
        BACK: "Tilbake",
    },
    RECEIPT: {
        HEADING: "Bestillingen er gjennomført!",
        ORDER_CONFIRMATION_SENT_TO: "Ordrebekreftelse sendes til",
        DOWNLOAD_RECEIPT: "Last ned kvittering (PDF)",
        DOWNLOADING_RECEIPT: "Laster ned kvittering…",
        DOWNLOAD_RECEIPT_ERROR: "Kunne ikke laste ned kvitteringen. Prøv igjen.",
        SHOW_ORDER: "Vis bestillingen min",
        PER_MONTH: "Per måned",
        CHECK_EMAIL: "Sjekk e-posten din for en enkel guide til Telia Play",
        GET_STARTED: {
            HEADING: "Vil du starte med en gang?",
            DOWNLOAD_HEADING: "Last ned Telia Play",
            DOWNLOAD_TEXT: "På mobil, nettbrett eller TV",
            LOGIN_HEADING: "Logg inn med Telia-profil",
            LOGIN_TEXT: "Samme innlogging som Min Side. Ny hos oss? Opprett en profil først",
            CREATE_PROFILE: "Opprett Telia-profil",
            CHOOSE_CONTENT_HEADING: "Velg innholdet ditt",
            CHOOSE_CONTENT_TEXT: (points?: number) =>
                `Bruk ${points ? `dine ${points} poeng` : "poengene dine"} på strømmetjenester og ekstrakanaler. Du kan bytte så ofte du vil`,
        },
        SUBSCRIPTION: "Abonnement",
        POINTS: (points: number) => `${points} poeng`,
        CHANGE_SUBSCRIPTION: {
            HEADING: "Bytt abonnement eller innhold",
            TEXT: "Når som helst på Min Side",
        },
        USEFUL_INFO: {
            HEADING: "Nyttig informasjon",
            // TODO: Replace placeholder texts with final copy
            ITEMS: [
                {
                    title: "Angrerett og betingelser",
                    text: "Du har 14 dagers angrerett fra bestillingen er gjennomført. Les mer om <a class='link' href='https://www.telia.no/kundeservice/vilkar-og-angrerett/' target='_blank' rel='noopener noreferrer'>vilkår og angrerett</a>.",
                },
                {
                    title: "Faktura og betaling",
                    text: "Telia Play faktureres månedlig. Du finner fakturaene dine på <a class='link' href='https://www.telia.no/minside/' target='_blank' rel='noopener noreferrer'>Min Side</a>.",
                },
                {
                    title: "Administrer ditt abonnement",
                    text: "Du kan endre abonnement, bytte innhold eller si opp når som helst på <a class='link' href='https://www.telia.no/minside/' target='_blank' rel='noopener noreferrer'>Min Side</a>.",
                },
            ],
        },
    },
    LINKS: {
        // TODO: Replace placeholder links with the real Telia Play app store links and Telia-profil registration URL
        APP_STORE: "#",
        GOOGLE_PLAY: "#",
        CREATE_PROFILE: "#",
        MIN_SIDE: "https://www.telia.no/minside/",
    },
    SUMMARY: {
        BROADBAND_CUSTOMER_TITLE: "Du kan bestille Telia Play på Min Side",
        BROADBAND_CUSTOMER_DESCRIPTION: "Siden du allerede har Telia Bredbånd, må du bestille Telia Play på Min Side",
        BROADBAND_CUSTOMER_LINK: "Gå til Min Side",
        MOBILE_CUSTOMER_DISCOUNT_TITLE: "Du får mobilkundrabatt.",
        MOBILE_CUSTOMER_DISCOUNT_DESCRIPTION: (monthlySaving: string) =>
            `Fordi du har mobilabonnement hos Telia, sparer du ${monthlySaving} kr hver måned`,
    },
};

export default TEXT;
